import React from 'react';
import { TextArea } from 'semantic-ui-react';

const TextAreaField = ({placeholder, style, value, name, onChange }) => (
    <TextArea 
    placeholder={placeholder} 
    style={style} 
    value={value} 
    name={name}
    onChange={onChange}
    />
);
export { TextAreaField };